"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mappingComp_1 = require("./mappingComp");
const botones_1 = require("../../botones");
const modal_1 = require("../../modal");
const dialogs_1 = require("../../dialogs");
class ExportComp extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.onGuardar = async () => {
            await this.props.onExportar();
            await dialogs_1.message("Exportación terminada", "", "success");
            this.props.onCerrar();
        };
    }
    render() {
        return (React.createElement(modal_1.Modal, { title: "Exportar a CSV", buttons: [React.createElement(botones_1.GuardarButton, { key: "guardar", onClick: this.onGuardar })], onClose: this.props.onCerrar },
            React.createElement(mappingComp_1.ColumnMappingComponent, { columnas: this.props.columnas, value: this.props.mapping, onChange: this.props.onMappingChange })));
    }
}
exports.ExportComp = ExportComp;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/export.js
// module id = 2219
// module chunks = 0